import apiService from '../apiService';

/** The firm-wide audit log (OL-156). Admins only; the server enforces it. */
const auditLogService = {
    async list(params = {}) {
        try {
            const response = await apiService.get('/audit-log', { params });
            return response.data;
        } catch (error) {
            throw error?.response?.data || error;
        }
    },

    async filters() {
        try {
            const response = await apiService.get('/audit-log/filters');
            return response.data;
        } catch (error) {
            throw error?.response?.data || error;
        }
    },

    /** The filtered log as CSV. The export itself is written to the log. */
    async exportCsv(params = {}) {
        try {
            const response = await apiService.get('/audit-log/export', { params, responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw error?.response?.data || error;
        }
    },
};

export default auditLogService;
